"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
const react_1 = __importDefault(require("react"));
const Option_scss_1 = __importDefault(require("./Option.scss"));
function Option({ value, label, selected = false, onClick = () => {
    /* do nothing */
}, }) {
    const clickHandler = () => onClick(value);
    return (react_1.default.createElement("div", { className: Option_scss_1.default.option, "data-selected": selected, onClick: clickHandler }, label));
}
exports.default = Option;
